import(/* webpackMode: "eager" */ "/app/node_modules/mapbox-gl/dist/mapbox-gl.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../../public/assets/fonts/geometria/Geometria-Regular.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../../public/assets/fonts/geometria/Geometria-Medium.ttf\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../../public/assets/fonts/geometria/Geometria-Bold.ttf\",\"weight\":\"700\",\"style\":\"normal\"}],\"display\":\"swap\",\"variable\":\"--font-geometria\"}],\"variableName\":\"fonts\"}");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ae.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/es.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/fr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ge.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/gr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ua.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/eur.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd.svg");
;
import(/* webpackMode: "eager", webpackExports: ["RootProviders"] */ "/app/src/app/[locale]/root-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoContainer"] */ "/app/src/components/ui/Common/InfoContainer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/PandaButton/PandaButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/widgets/ScrollToTop/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/src/providers/nextIntlProvider.tsx");
